import { AxiosError } from 'axios';

export function parseErrorMessage(e: unknown): string {
  const axiosError = e as AxiosError;
  const response = axiosError.response?.data;

  if (response) {
    if (typeof response === 'string') return response;
    return JSON.stringify(response, null, 2);
  } else {
    return axiosError.message || 'Es ist ein Fehler aufgetreten';
  }
}
